export default "__VITE_ASSET__D697_zNp__"